// A widget's first step, the same everywhere: what it shows once set up, what
// it connects or asks for, and one obvious button. The brief's own empty state
// set the look (brief.tsx); a short tile drops the words, then the icon.

import type { ReactNode } from "react";
import { Globe2, Plug } from "lucide-react";
import type { WidgetItem } from "../../shared/types";
import { set } from "../state/store";
import { cx } from "../lib/util";

/**
 * problem: what went wrong with the last try, said in place of sub, and kept in a short tile. tile: the step's own
 * buttons and fields take clicks, and the rest of it is the tile's, so a double-click there opens its settings as on
 * any data widget.
 */
export function Setup({ icon, title, sub, problem, note, children, className, tile }: { icon: ReactNode; title: string; sub?: ReactNode; problem?: string | null; note?: ReactNode; children?: ReactNode; className?: string; tile?: boolean }) {
  return (
    <div className={cx("setup", className)} data-interactive={tile ? undefined : true}>
      <span className="setup-ico">{icon}</span>
      <b className="setup-title">{title}</b>
      {problem ? <span className="setup-sub is-bad">{problem}</span> : sub && <span className="setup-sub">{sub}</span>}
      {children && <div className="setup-acts">{children}</div>}
      {note && <span className="setup-note">{note}</span>}
    </div>
  );
}

/** Connect, open on the widget asking: its likely places first. */
export const openConnect = (item: WidgetItem, more: Record<string, unknown> = {}) => set({ panel: "connect", panelArg: { tab: "data", stream: item.stream ?? null, item: item.id, ...more } });

/** A world map with nothing behind it yet: it shows visitors by country, and Google Analytics sends them. */
export function MapSetup({ item }: { item: WidgetItem }) {
  return (
    <Setup
      icon={<Globe2 />}
      title="Where your visitors are"
      sub="Connect Google Analytics and the map lights up each country your visitors come from, with the top ones listed."
      note={
        <button className="link-btn" onClick={() => openConnect(item)}>
          Or connect something else
        </button>
      }
    >
      <button className="btn btn-sm btn-primary" onClick={() => openConnect(item, { google: true })}>
        <Plug size={13} /> Connect Google Analytics
      </button>
    </Setup>
  );
}
